// const supportingInfoElements = [
//   {
//     id: 1,
//     name: "Attachment",
//     object: {
//       category: "attachment",
//       attachment: "",
//       fileName: "",
//       fileType: "",
//     },
//   },
//   {
//     id: 2,
//     name: "Birth Weight",
//     object: {
//       category: "birth-weight",
//       value: null,
//       valueUnit: "kg",
//     },
//   },
//   {
//     id: 3,
//     name: "Chief Complaint",
//     object: {
//       category: "chief-complaint",
//       codeText: "",
//       code: "",
//       valueUnit: "",
//       value: null,
//     },
//   },
//   {
//     id: 4,
//     name: "Days Supply",
//     object: {
//       category: "days-supply",
//       valueUnit: "d",
//       value: null,
//     },
//   },
//   {
//     id: 5,
//     name: "Employment Impacted",
//     object: {
//       category: "employment-impacted",
//       startDate: null,
//       endDate: null,
//     },
//   },
//   {
//     id: 6,
//     name: "Hospitalized",
//     object: {
//       category: "hospitalized",
//       startDate: null,
//       endDate: null,
//     },
//   },
//   {
//     id: 7,
//     name: "ICU Hours",
//     object: {
//       category: "icu-hours",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "h",
//     },
//   },
//   {
//     id: 8,
//     name: "Info",
//     object: {
//       category: "info",
//       value: null,
//       valueUnit: "",
//     },
//   },
//   {
//     id: 9,
//     name: "Lab Test",
//     object: {
//       category: "lab-test",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "",
//       codeText: "",
//       code: "",
//     },
//   },
//   {
//     id: 10,
//     name: "Last Menstrual Period",
//     object: {
//       category: "last-menstrual-period",
//       startDate: null,
//     },
//   },
//   {
//     id: 11,
//     name: "Missing Tooth",
//     object: {
//       category: "missingtooth",
//       startDate: null,
//       codeText: "",
//       code: "",
//       reason: null,
//     },
//   },
//   {
//     id: 12,
//     name: "Onset",
//     object: {
//       category: "onset",
//       startDate: null,
//       codeText: "",
//       code: "",
//     },
//   },
//   {
//     id: 13,
//     name: "Oxygen Saturation",
//     object: {
//       category: "oxygen-saturation",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "%",
//     },
//   },
//   {
//     id: 14,
//     name: "Pulse",
//     object: {
//       category: "pulse",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "/min",
//     },
//   },
//   {
//     id: 15,
//     name: "Reason For Visit",
//     object: {
//       category: "reason-for-visit",
//       codeText: "",
//       code: "",
//     },
//   },
//   {
//     id: 16,
//     name: "Respiratory Rate",
//     object: {
//       category: "respiratory-rate",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "/min",
//     },
//   },
//   {
//     id: 17,
//     name: "Temperature",
//     object: {
//       category: "temperature",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "Cel",
//     },
//   },
//   {
//     id: 18,
//     name: "Ventilation Hours",
//     object: {
//       category: "ventilation-hours",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "h",
//     },
//   },
//   {
//     id: 19,
//     name: "Vital Sign Diastolic",
//     object: {
//       category: "vital-sign-diastolic",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "mm[Hg]",
//     },
//   },
//   {
//     id: 20,
//     name: "Vital Sign Height",
//     object: {
//       category: "vital-sign-height",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "cm",
//     },
//   },
//   {
//     id: 21,
//     name: "Vital Sign Systolic",
//     object: {
//       category: "vital-sign-systolic",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "mm[Hg]",
//     },
//   },
//   {
//     id: 22,
//     name: "Vital Sign Weight",
//     object: {
//       category: "vital-sign-weight",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "kg",
//     },
//   },
// ];

// export default supportingInfoElements;

import AttachFileIcon from '@mui/icons-material/AttachFile';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import WarningIcon from '@mui/icons-material/Warning';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoIcon from '@mui/icons-material/Info';
import ScienceIcon from '@mui/icons-material/Science';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AirIcon from '@mui/icons-material/Air';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import HeightIcon from '@mui/icons-material/Height';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'; // For vital-sign-systolic
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'; // For vital-sign-diastolic
import EventIcon from '@mui/icons-material/Event'; // For last-menstrual-period
import { tabScrollButtonClasses } from '@mui/material';

const supportingInfoElements = (t = () => {}) => [
  {
    id: 1,
    name: t('Attachment'),
    icon: <AttachFileIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'attachment',
      attachment: '',
      fileName: '',
      fileType: ''
    }
  },
  {
    id: 2,
    name: t('Birth Weight'),
    icon: <ChildFriendlyIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'birth-weight',
      value: null,
      valueUnit: 'kg'
    }
  },
  {
    id: 3,
    name: t('Chief Complaint'),
    icon: <WarningIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'chief-complaint',
      codeText: '',
      code: '',
      valueUnit: '',
      value: null
    }
  },
  {
    id: 4,
    name: t('Days Supply'),
    icon: <CalendarTodayIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'days-supply',
      valueUnit: 'd',
      value: null
    }
  },
  {
    id: 5,
    name: t('Employment Impacted'),
    icon: <WorkOffIcon />,
    object: {
      category: 'employment-impacted',
      startDate: null,
      endDate: null
    }
  },
  // {
  //   id: 6,
  //   name: "Hospitalized",
  //   icon: <LocalHospitalIcon />,
  //   object: {
  //     category: "hospitalized",
  //     startDate: null,
  //     endDate: null,
  //   },
  // },
  {
    id: 7,
    name: t('ICU Hours'),
    icon: <AccessTimeIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'icu-hours',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'h'
    }
  },
  {
    id: 8,
    name: t('Info'),
    icon: <InfoIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'info',
      value: null,
      valueUnit: ''
    }
  },
  {
    id: 9,
    name: t('Lab Test'),
    icon: <ScienceIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'lab-test',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '',
      codeText: '',
      code: ''
    }
  },
  {
    id: 10,
    name: t('Last Menstrual Period'),
    icon: <EventIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'last-menstrual-period',
      startDate: null
    }
  },
  {
    id: 11,
    name: t('Missing Tooth'),
    icon: <SentimentVeryDissatisfiedIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'missingtooth',
      startDate: null,
      codeText: '',
      code: '',
      reason: null
    }
  },
  {
    id: 12,
    name: t('Onset'),
    icon: <PlayArrowIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'onset',
      startDate: null,
      codeText: '',
      code: ''
    }
  },
  {
    id: 13,
    name: t('Oxygen Saturation'),
    icon: <FavoriteIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'oxygen-saturation',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '%',
      reason: '888'
    }
  },
  {
    id: 14,
    name: t('Pulse'),
    icon: <FavoriteBorderIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'pulse',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '/min',
      reason: '998'
    }
  },
  {
    id: 15,
    name: t('Reason For Visit'),
    icon: <EventNoteIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'reason-for-visit',
      codeText: '',
      code: ''
    }
  },
  {
    id: 16,
    name: t('Respiratory Rate'),
    icon: <AirIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'respiratory-rate',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '/min',
      reason: '88'
    }
  },
  {
    id: 17,
    name: t('Temperature'),
    icon: <ThermostatIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'temperature',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'Cel',
      reason: '88'
    }
  },
  {
    id: 18,
    name: t('Ventilation Hours'),
    icon: <AirIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'ventilation-hours',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'h'
    }
  },
  {
    id: 19,
    name: t('Vital Sign Diastolic'),
    icon: <ArrowDownwardIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'vital-sign-diastolic',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'mm[Hg]',
      reason: '888'
    }
  },
  {
    id: 20,
    name: t('Vital Sign Height'),
    icon: <HeightIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'vital-sign-height',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'cm',
      reason: '999.9'
    }
  },
  {
    id: 21,
    name: t('Vital Sign Systolic'),
    icon: <ArrowUpwardIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'vital-sign-systolic',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'mm[Hg]',
      reason: '888'
    }
  },
  {
    id: 22,
    name: t('Vital Sign Weight'),
    icon: <MonitorWeightIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'vital-sign-weight',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'kg',
      reason: '999.9'
    }
  },

  {
    id: 23,
    name: t('History of Present Illness'),
    icon: <InfoIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'history-of-present-illness',
      value: 'none',
      valueUnit: ''
    }
  },
  {
    id: 24,
    name: t('Past Medical & Surgical Historys'),
    icon: <InfoIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'patient-history',
      value: 'none',
      valueUnit: ''
    }
  },
  {
    id: 25,
    name: t('Physical Examination'),
    icon: <InfoIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'physical-examination',
      value: 'none',
      valueUnit: ''
    }
  },
  {
    id: 26,
    name: t('Treatment Plan'),
    icon: <InfoIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'treatment-plan',
      value: 'none',
      valueUnit: ''
    }
  },
  {
    id: 27,
    name: t('Estimated Length of Stay'),
    icon: <InfoIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'estimated-Length-of-Stay',
      value: '1',
      valueUnit: 'd'
    }
  },
  {
    id: 28,
    name: t('Morphology'),
    icon: <WarningIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'morphology',
      codeText: '',
      code: ''
    }
  },
  {
    id: 29,
    name: t('Investigation Result'),
    icon: <SentimentVeryDissatisfiedIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'investigation-result',
      codeText: 'Not applicable or Other',
      code: 'NA',
      attachment: '',
      fileName: '',
      fileType: ''
    }
  },
  {
    id: 30,
    name: t('Admission Weight'),
    icon: <ChildFriendlyIcon sx={{ fontSize: 20 }} />,
    object: {
      category: 'admission-weight',
      value: null,
      valueUnit: 'kg'
    }
  }
];

export default supportingInfoElements;
